export const EMPLOYER_BRANDING_META_DESCRIPTION_BG =
  "Анализ на работодателския бранд за HR и employer branding екипи - проследяване на възприятията, конкурентите и репутационните рискове с Perceptica.";
